import type { LogQLVendor, VendorConfig } from '../types';
import slsConfig from './sls';
import clsConfig from './cls';
import tlsConfig from './tls';
import ltsConfig from './lts';
import blsConfig from './bls';

const CONFIGS: Record<LogQLVendor, VendorConfig> = {
  sls: slsConfig,
  cls: clsConfig,
  tls: tlsConfig,
  lts: ltsConfig,
  bls: blsConfig,
};

export function getVendorConfig(vendor: LogQLVendor): VendorConfig {
  return CONFIGS[vendor];
}

export const ALL_VENDORS: LogQLVendor[] = ['sls', 'cls', 'tls', 'lts', 'bls'];

export { slsConfig, clsConfig, tlsConfig, ltsConfig, blsConfig };
